import React from 'react';
import styled, { css } from 'styled-components/macro';

interface IProps {
  size?: 'introduction';
  weight?: 'light' | 'semibold' | 'bold';
}

export const StylesParagraph = css<Pick<IProps, 'weight'>>`
  font-size: ${({ theme }) => theme.typography[-1]};
  line-height: 1.8;
  margin-bottom: ${({ theme }) => theme.spacing[2]};

  font-weight: ${({ weight }) => {
    switch (weight) {
      case 'light':
        return 300;
      case 'semibold':
        return 500;
      case 'bold':
        return 600;
      default:
        return 400;
    }
  }};

  &:last-child {
    margin-bottom: 0;
  }
`;

const StyledParagraph = styled.p<IProps>`
  ${StylesParagraph};
  font-size: ${({ size, theme }) => size !== 'introduction' ? theme.typography[-1] : theme.typography[0]};
`;

const Paragraph: React.FC<IProps> = ({ size, weight, children }) => {
  return <StyledParagraph size={size} weight={weight}>{children}</StyledParagraph>;
};

export { Paragraph };